import { PageLayout } from '@components/PageLayout/PageLayout';
import { NextPage } from 'next';
import s from './settingsPage.module.scss';
import cn from 'classnames';
import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import { useTranslation } from '@hooks/useTranslation';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
import { useUserAgent } from 'next-useragent';
import { AvatarBlock } from '@components/Pages/SettingsPage/AvatarBlock/AvatarBlock';
import { InputsBlock } from '@components/Pages/SettingsPage/InputsBlock/InputsBlock';
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => ({
  ...props
}));
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = ({
  agent
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    isMobile
  } = useUserAgent(agent ?? '');
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.settingsPage}>
                <div className={cn(s.settingsPage__container, '_container')}>
                    <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                    <div className={s.settingsPage__top}>
                        <div className={cn(s.settingsPage__title, '_title')}>
                            {tr({
              id: 'settings.page.title'
            })}
                        </div>
                    </div>
                    <div className={s.settingsPage__main}>
                        <div className={s.settingsPage__form}>
                            <AvatarBlock data-sentry-element="AvatarBlock" data-sentry-source-file="index.tsx" />
                            <InputsBlock isMobile={isMobile} data-sentry-element="InputsBlock" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>;
};
export default Page;